import React from 'react'
import NavBar from './property-listing/Navbar';
import SideBar from './property-listing/LeftSideBar';
import Form from './AddNewProperty/Form';
const Desktop1 = () => {
  return (
      <>
    <NavBar/>
    <SideBar/>
    <Form/>
    </>
  )
}

export default Desktop1